module.exports = __webpack_public_path__ + "static/media/datacamp_logo.c368c23a.png";